import React, { FC, ReactNode } from "react";
import { Row } from 'antd';

import Header from "../components/header";
import Sidebar from "../components/sidebar";
// import ActionBar from "../components/action-bar";
import useSession from "../utils/useSession";
import './default.scss';
import classNames from "classnames";
import Logo from "@assets/logo.png";

export type LayoutProps = {
  children: ReactNode;
  members?:any
  updateMembers?: any,
  noPadding?: any
  className?: any
};

const LayoutOfDashboard: FC<LayoutProps> = ({ children, members, updateMembers, noPadding, className }: LayoutProps) => {
  const session = useSession();

  const pageviewWrapperClassName = classNames( "pageViewWrapperForDashboard  ui-dashboard", className, {
    "pageViewWrapperForDashboard--no-padding": noPadding
  } )

  return(
    <>
      <Header 
        logo={Logo} 
        companyName="Company Name" 
        userName={session?.user?.firstName}
      />
      <Row className="root-body">
        <div className="sidebarWrapper sideWrapper-dashboard">
          <Sidebar />
        </div>
        <div className={pageviewWrapperClassName}>{children}</div>
        
      </Row>
      

    </>
  );
};

export default LayoutOfDashboard;
